// extracted by mini-css-extract-plugin
module.exports = {"sort":"Sort_sort__WsaF8","toggle":"Sort_toggle__1ESPd"};